module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAABCAIAAACaK/2MAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABNJREFUeNpilFRSZBgFtAcAAQYAg84AXhbvmAMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/mill/logo-bg-helper.png
// module id = f1Bp
// module chunks = 1